import React from 'react';
import { BrowserRouter, Routes, Route, useSearchParams } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from './components/ui/sonner';
import Home from './pages/Home';
import Jobs from './pages/Jobs';
import JobDetail from './pages/JobDetail';
import ZohoJobDetail from './pages/ZohoJobDetail';
import ApplyJob from './pages/ApplyJob';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminSettings from './pages/AdminSettings';
import AdminResumeSubmissions from './pages/AdminResumeSubmissions';
import AdminPublicApplications from './pages/AdminPublicApplications';
import AdminAnalytics from './pages/AdminAnalytics';
import JobEditor from './pages/JobEditor';
import { EmbedProvider } from './contexts/EmbedContext';
import '@/App.css';

// Router component
function AppRouter() {
  const [searchParams] = useSearchParams();
  const isEmbed = searchParams.get('embed') === 'true';
  
  return (
    <Routes>
      {/* Public Routes - No Login Required */}
      <Route path="/" element={<Home />} />
      <Route path="/jobs" element={<Jobs />} />
      <Route path="/jobs/:id" element={<JobDetail />} />
      <Route path="/jobs/zoho/:id" element={<ZohoJobDetail />} />
      <Route path="/apply" element={<ApplyJob />} />
      
      {/* Admin Routes */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/dashboard/admin" element={<AdminDashboard />} />
      <Route path="/admin/settings" element={<AdminSettings />} />
      <Route path="/admin/resume-submissions" element={<AdminResumeSubmissions />} />
      <Route path="/admin/public-applications" element={<AdminPublicApplications />} />
      <Route path="/admin/analytics" element={<AdminAnalytics />} />
      <Route path="/admin/jobs/new" element={<JobEditor />} />
      <Route path="/admin/jobs/:id/edit" element={<JobEditor />} />
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <EmbedProvider>
          <div className="App">
            <Toaster position="top-right" richColors />
            <AppRouter />
          </div>
        </EmbedProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
